import React from "react";
import PropTypes from "prop-types";

import IconView from "@/shared/components/IconView/IconView";
import EgwWebFont from "src/assets/EgwWebFont";
import { Button } from "@/components/index";
import SharePopup from "./SharePopup";

const ButtonShare = ({ url, text, refCode, title, className }) => {
  return (
    <SharePopup
      text={text}
      refCode={refCode}
      title={title}
      url={url}
      renderButton={({ show, onClick }) => {
        return (
          <Button
            active={show}
            className={className}
            onClick={onClick}
          >
            <IconView icon={EgwWebFont.share} />
          </Button>
        );
      }}
    />
  );
};

ButtonShare.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  refCode: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
};

export default ButtonShare;
